/**
 * ArticleRelated - related articles block on a blog article.
 * Custom element: <article-related>
 *
 * Attributes (from $info):
 *   article-id     Number  -
 *   article-title  String  -
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent, dataLayerPush } from "./theme.js";
import "./vendor.js";
class ArticleRelated extends ThemeComponent {
  init() {
    this.$listen(this, "click", clickEvent => {
      const eventTarget = clickEvent.target;
      if (!eventTarget) return;
      const articleCard = eventTarget.closest("article-card[data-article-id]");
      if (!articleCard || !eventTarget.closest("a[href]")) return;
      const cardIndex = Array.from(this.querySelectorAll("article-card[data-article-id]")).indexOf(articleCard),
        targetArticleId = Number(articleCard.dataset.articleId);
      dataLayerPush({
        event: "select_related_article",
        source_article_id: this.articleId,
        target_article_id: Number.isFinite(targetArticleId) ? targetArticleId : void 0,
        target_article_title: articleCard.dataset.articleTitle,
        target_article_url: articleCard.dataset.articleUrl,
        index: cardIndex >= 0 ? cardIndex : void 0,
        item_list_name: "related_articles"
      });
    });
  }
}
setFunctionName(ArticleRelated, "ArticleRelated");
const propertyTypes = {
  Number,
  String
};
ArticleRelated.prototype.$name = "ArticleRelated";
ArticleRelated.prototype.$info = JSON.parse('{"name":"ArticleRelated","meta":{"isLegacy":false,"selector":"article-related"},"props":[{"attr":"article-id","reflectAttr":false,"propertyKey":"articleId","propertyType":"Number","propertyTypeName":"Number","propertyTsTypeName":"number"},{"attr":"article-title","reflectAttr":false,"propertyKey":"articleTitle","propertyType":"String","propertyTypeName":"String","propertyTsTypeName":"string"}],"refs":[]}');
ArticleRelated.prototype.$info.component = ArticleRelated;
for (const prop of ArticleRelated.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Article/ArticleRelated.ts", {
  ArticleRelated: ArticleRelated
}, void 0);